import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { currencyFormatter } from '@techsoftware/happay-widgets/CommonFunction/commonFunction';
import { Grid, Icons } from '@techsoftware/happay-widgets';
import Locales from '../../../../constants/locales';

export default function AmountFormatter(props) {
  const [state, setState] = useState({});
  const { data } = props;
  let defaultCurrency = Locales.currency;
  const { amount, currency, txn_type_debit_type = undefined } = data;
  return (
    <Grid container justify='flex-end' alignItems='center'>
      {/* <div className=""> */}
      {currencyFormatter(amount, currency || defaultCurrency)}
      {/* </div> */}
      {txn_type_debit_type !== undefined && (
        <Icons
          type="arrow-right"
          size="small"
          className={`padding-l-10 ${
            txn_type_debit_type
              ? 'alert-red-color'
              : 'primary-green-color'
          }`}
          rotate={txn_type_debit_type ? 90 : 270}
        />
      )}
    </Grid>
    //   {currency_amount && data !== currency_amount ? (
    //     <div className="micro light pos-absolute right-26">
    //       {currencyFormatter(currency_amount, currency)}
    //     </div>
    //   ) : null}
    //   {dispute && Object.keys(dispute).length > 0 && dispute.status !== '1' ? (
    //     <>
    //       <span
    //         className="dispute_tag margin-l-6"
    //         id={`disputeSymbol-${txn_id}`}
    //         onMouseOver={ev => {
    //           ev.preventDefault();
    //           ev.stopPropagation();
    //           setState({
    //             ...state,
    //             tooltip: true,
    //             targetId: ev.target.id,
    //             disputeTooltipStatus: dispute?.display_status,
    //           });
    //           // const disputeStatus = dispute?.display_status;
    //           // onAmountHover(true, ev.target.id, disputeStatus);
    //         }}
    //       >
    //         <img
    //           src={DISPUTEICON}
    //           alt="dispute"
    //           className="pointer"
    //           id={`disputeSymbol-${txn_id}`}
    //         />
    //       </span>
    //     </>
    //   ) : null}
    //   {state.tooltip && (
    //     <Popup
    //       id="disputeTooltip"
    //       parentElementId={state.targetId}
    //       pointerPlacement="right-center"
    //       open={state.tooltip}
    //       onWrapperMouseMove={({ clientX, clientY }) => {
    //         const { x, y, width, height } = document
    //           .getElementById(state.targetId)
    //           .getBoundingClientRect();

    //         if (
    //           clientX >= x &&
    //           clientX <= x + width &&
    //           clientY >= y &&
    //           clientY <= y + height
    //         ) {
    //         } else {
    //           setState({ ...state, tooltip: false });
    //         }
    //       }}
    //       popupStyle={{
    //         width: '276px',
    //         height: '186px',
    //         padding: '16px 16px 27px 20px',
    //         boxShadow: '0 4px 6px 0 rgba(0, 0, 0, 0.15)',
    //         color: 'white',
    //       }}
    //       backgroundColor="#0b1322"
    //       borderStyle="borderRadius: 2px"
    //     >
    //       <div
    //         className="font-12 margin-b-10"
    //         style={{ color: '#e0e0e0', width: '240px' }}
    //       >
    //         Transaction has been disputed with the merchant and temporary credit
    //         extended against it. The temporary credit amount is blocked and not
    //         available for use till the claim is settled with the merchant.
    //       </div>
    //       <div>
    //         <div style={{ color: '#9e9e9e' }} className="font-10">
    //           Current Status:{' '}
    //         </div>
    //         <div
    //           style={{ color: '#e0e0e0' }}
    //           className="font-12 fw-600 margin-b-6"
    //         >
    //           {' '}
    //           {state.disputeTooltipStatus}{' '}
    //         </div>
    //       </div>
    //     </Popup>
    //   )}
    // </div>
  );
}
AmountFormatter.propTypes = {
  data: PropTypes.object,
  // row: PropTypes.object,
  // item: PropTypes.string,
  // onAmountHover: PropTypes.func,
};
AmountFormatter.defaultProps = {
  data: {},
  // row: {},
  // onAmountHover: () => {},
};
